export default __webpack_public_path__ + "static/media/img3.a92a9e72.webp";